import {BUDGET_TYPE, PERIOD_BUDGET_TYPE, QUANTITY_LOCKED_REASON} from '../../../../constants';
import {convertPriceToInvoiceCurrency, createPeriodDescription, addQuantityDecimals} from './invoicing_generate_lines_utils';
import {sortByStartDate} from '../../../../forecast-app/project-tab/projects/project-retainer-periods/RetainerPeriodUtil';

const generateLinesForFixedPriceProject = (project, invoice, company) => {
	const projectCurrency = project.rateCard ? project.rateCard.currency : company.currency;
	const alreadyInvoicedForProject = project.invoiceTotals.reduce(
		(totalInvoiced, invoice) => totalInvoiced + invoice.invoicedWithoutTax,
		0
	);
	let fixedPriceRemaining = project.budget - alreadyInvoicedForProject;
	if (fixedPriceRemaining) {
		const description = `${project.name}`;
		const quantity = 1;
		const unitPrice = convertPriceToInvoiceCurrency(fixedPriceRemaining, projectCurrency, company, invoice);
		const projectId = project.id;
		const tax = invoice.tax;
		const discount = invoice.discount;

		return [
			{
				description,
				quantity: addQuantityDecimals(quantity, company),
				unitPrice,
				projectId,
				tax,
				discount,
				quantityLockedReason: QUANTITY_LOCKED_REASON.FIXED_PRICE,
			},
		];
	} else {
		return [];
	}
};

const generateLinesForRetainerProject = (project, invoice, intl, company) => {
	const periodsToInvoice = project.retainerPeriods.edges
		.map(edge => edge.node)
		.sort(sortByStartDate)
		.filter(
			period => period.periodBudgetType === PERIOD_BUDGET_TYPE.FIXED_PRICE && period.periodLocked && !period.invoiced
		);
	if (periodsToInvoice.length > 0) {
		const periodLines = [];
		periodsToInvoice.forEach(period => {
			const description = createPeriodDescription(period, intl);
			const quantity = 1;
			let unitPrice = period.periodPriceAmount;
			const projectCurrency = project.rateCard ? project.rateCard.currency : company.currency;
			unitPrice = convertPriceToInvoiceCurrency(unitPrice, projectCurrency, company, invoice);
			const projectId = project.id;
			const tax = invoice.tax;
			const discount = invoice.discount;
			const periodIds = [period.id];
			periodLines.push({
				description,
				quantity: addQuantityDecimals(quantity, company),
				unitPrice,
				projectId,
				tax,
				discount,
				periodIds,
				quantityLockedReason: QUANTITY_LOCKED_REASON.FIXED_PRICE_PERIOD,
			});
		});
		return periodLines;
	} else {
		return [];
	}
};

export const generateLinesForFixedPrice = (intl, invoice, projects, company) => {
	const invoiceLines = [];

	projects.forEach(project => {
		if (project.budgetType === BUDGET_TYPE.FIXED_PRICE || project.budgetType === BUDGET_TYPE.FIXED_PRICE_V2) {
			invoiceLines.push(...generateLinesForFixedPriceProject(project, invoice, company));
		} else if (project.budgetType === BUDGET_TYPE.RETAINER) {
			invoiceLines.push(...generateLinesForRetainerProject(project, invoice, intl, company));
		}
	});

	return invoiceLines;
};
